module.exports = __webpack_public_path__ + "static/media/southbay.546266ee.png";